import script from "./viewWorkflowDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./viewWorkflowDetails.vue?vue&type=script&setup=true&lang=js"

import "./viewWorkflowDetails.vue?vue&type=style&index=0&id=059881a7&scoped=true&lang=css"
import "./viewWorkflowDetails.vue?vue&type=style&index=1&id=059881a7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-059881a7"]])

export default __exports__